import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useBatchService from '../../../app/services/hooks/useBatchService';
import { BatchDataForm } from '../../../app/models/Batch';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import BatchForm from './forms/BatchForm';

interface Props {
  onSaved?: () => void;
  onCancel?: () => void;
  onError?: () => void;
}

type SelectOpt = { id: number | string; name: string; quality__name?: string | null };

const NOOP = () => undefined;

const BatchCreate = ({ onSaved, onCancel, onError }: Props) => {
  const { showLoading, hideLoading } = useContext(AppContext);
  const { createBatch, storeBatch, fetchingStoreBatch } = useBatchService();

  const handleCancel = onCancel ?? NOOP;

  const [batch, setBatch] = useState<BatchDataForm>({
    batch_category: 'COLLECTION',
    // nuevos
    society_id: null,
    warehouse_id: null,
    product_id: null,
    quality: '',
    // existentes
    project_id: null,
    center_id: null,
    unit_id: null,
    capacity: 0,
    quantity: 0,
    is_active: true,
  });

  const [projects, setProjects] = useState<SelectOpt[]>([]);
  const [centers, setCenters] = useState<SelectOpt[]>([]);
  const [units, setUnits] = useState<SelectOpt[]>([]);
  const [batchCategories, setBatchCategories] = useState<SelectOpt[]>([]);
  const [societies, setSocieties] = useState<SelectOpt[]>([]);
  const [warehouses, setWarehouses] = useState<SelectOpt[]>([]);
  const [products, setProducts] = useState<SelectOpt[]>([]);
  const [errorFields, setErrorFields] = useState<any>();

  useEffect(() => { create(); }, []);

  const create = () => {
    showLoading?.('loading', 'Cargando datos de formulario...');
    createBatch({
      onSuccess: (response: ServiceResponse) => {
        setProjects(response.data.projects || []);
        setCenters(response.data.centers || []);
        setUnits(response.data.units || []);
        setBatchCategories(response.data.batch_categories || []);
        setSocieties(response.data.societies || []);
        setWarehouses(response.data.warehouses || []);
        setProducts(response.data.products || []);
        hideLoading?.();
      },
      onError: (response: ServiceResponse) => {
        hideLoading?.();
        toast.error(response.message);
        onError && onError();
      }
    });
  };

  const store = () => {
    showLoading?.('loading', 'Guardando lote...');
    // Al crear un lote, quantity siempre debe ser 0 (no se envía desde el formulario)
    const batchToStore = { ...batch };
    // Eliminamos quantity del payload ya que siempre debe ser 0 al crear
    delete batchToStore.quantity;
    storeBatch(batchToStore, {
      onSuccess: (response: ServiceResponse) => {
        hideLoading?.();
        toast.success(response.message, { autoClose: 2500 });
        onSaved && onSaved();
      },
      onError: (response: ServiceResponse) => {
        hideLoading?.();
        toast.error(response.message);
      },
      onFieldError: (errs: ServiceResponse) => {
        hideLoading?.();
        setErrorFields(errs.data);
      }
    });
  };

  return (
    <>
      <div className="row"><div className="col-12">
        <BatchForm
          batchDataForm={batch}
          setBatchDataForm={setBatch}
          projects={projects}
          centers={centers}
          units={units}
          batchCategories={batchCategories}
          societies={societies}
          warehouses={warehouses}
          products={products}
          errorFields={errorFields}
        />
      </div></div>
      <hr />
      <div className="row justify-content-end">
        <div className="col-auto">
          <ButtonCancelForm callbackCancel={handleCancel} locked={!!fetchingStoreBatch} />
        </div>
        <div className="col-auto">
          <ButtonSaveForm callbackSave={store} locked={!!fetchingStoreBatch} />
        </div>
      </div>
    </>
  );
};

export default BatchCreate;
